import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'mkt-check',
  templateUrl: './mkt-check.component.html',
  styleUrls: ['./mkt-check.component.scss', '../../mk-table.comp.scss', '../../mk-table.comp.input.scss'],
  host:{
    "class" : 'mkt_col col-check',
    "[class.has-change]": "_hasChange",
    "[class.readonly]": "readonly"
  }
})
export class MktCheckComponent implements OnInit {

  @Input() value: boolean;
  @Output() valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() readonly: boolean;

  private _hasChange: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  //ngOnChanges(): void{this._hasChange = true; setTimeout(() => {this._hasChange = false}, 2000);}
  public emitValue(ev: any){this.valueChange.emit(ev)}

}
